<!-- Empty / baseline state: cognitive module not completed for this scan -->
<div *ngIf="!vm.available" class="card" style="margin-bottom:12px;padding:20px 18px;text-align:center;">
  <div style="font-size:15px;font-weight:800;color:var(--navy);margin-bottom:8px;">{{ 'results.th.empty.title' | translate }}</div>
  <p style="font-size:12.5px;color:var(--g500);line-height:1.6;margin:0;">{{ 'results.th.empty.body' | translate }}</p>
</div>

<ng-container *ngIf="vm.available">
  <!-- HERO -->
  <div class="card hi-hero-card" style="margin-bottom:12px;padding:16px 18px 14px;">
    <div style="display:flex;align-items:baseline;gap:7px;margin-bottom:4px;">
      <div style="font-size:15px;font-weight:800;color:var(--navy);letter-spacing:-0.2px;">{{ 'results.th.title' | translate }}</div>
      <div dir="ltr" style="font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:var(--g400);">THINK™</div>
    </div>
    <div style="font-size:10px;color:var(--g400);margin-bottom:10px;">{{ 'results.th.subtitle' | translate }}</div>

    <!-- wordfirst sec 2: evaluation WORD + 3-level bar; the composite number moves
         into the reveal below. -->
    <app-band-scale [band]="vm.band" [config]="bandConfig" [score]="vm.composite" [aboutKey]="'results.about.think'"></app-band-scale>

    <div class="hi-hero-copy" style="margin-top:13px;">
      <p style="font-size:13px;font-weight:700;color:var(--navy);line-height:1.45;margin:0;">{{ vm.headlineKey | translate: { domain: (vm.weakestTitleKey ? (vm.weakestTitleKey | translate) : '') } }}</p>
      <p style="font-size:12px;color:var(--g600);line-height:1.65;margin:0;">{{ vm.subCopyKey | translate }}</p>
    </div>

    <div style="font-size:11px;color:var(--g500);line-height:1.55;margin-top:10px;">{{ 'results.th.disclaimer' | translate }}</div>

    <details class="reveal" *ngIf="vm.composite !== null">
      <summary>
        <svg class="rev-chev" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="6 9 12 15 18 9"/></svg>
        {{ 'results.reveal.numbersBehind' | translate }}
      </summary>
      <div class="rev-body">
        <div class="numrow">
          <div class="bignum">{{ vm.composite }}<span>/100</span></div>
          <div style="flex:1;min-width:0;">
            <span class="dir-chip">{{ 'results.th.higherStronger' | translate }}</span>
            <p>{{ 'results.reveal.scoreNote' | translate }}</p>
          </div>
        </div>
      </div>
    </details>
  </div>

  <!-- PROGRESS OVER TIME (#22) -->
  <app-progress-card [vm]="progress" (goPaywall)="goPaywall.emit()"></app-progress-card>

  <!-- DEEP DIVE -->
  <details class="ia-deep">
    <summary class="ia-deep-toggle">
      <div>
        <div>{{ 'results.th.deepTitle' | translate }}</div>
        <div style="font-size:11px;font-weight:500;color:var(--g400);margin-top:2px;">{{ 'results.th.deepSub' | translate }}</div>
      </div>
      <svg class="ia-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg>
    </summary>

    <div class="card skin-score-card" style="margin-top:10px;" *ngFor="let t of vm.tasks">
      <div style="font-size:14px;font-weight:700;color:var(--navy);margin-bottom:2px;">{{ t.titleKey | translate }}</div>
      <div style="font-size:11px;color:var(--g400);margin-bottom:12px;">{{ t.subtitleKey | translate }}</div>
      <div style="margin-bottom:10px;">
        <div style="font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;color:var(--g400);margin-bottom:4px;">{{ 'results.th.whatItMeasures' | translate }}</div>
        <p style="font-size:13px;color:var(--g600);line-height:1.6;margin:0 0 12px;">{{ t.whatKey | translate }}</p>
      </div>
      <div style="padding-top:6px;border-top:1px solid var(--g100);">
        <div class="ia-score-row" style="border-bottom:none;">
          <div style="flex:1;min-width:0;"><div style="font-size:13px;font-weight:600;color:var(--navy);">{{ 'results.th.yourResult' | translate }}</div></div>
          <div class="ia-bar-track"><div class="ia-bar-fill" [style.width.%]="t.pct" [style.background]="t.color"></div></div>
          <div class="ia-average-value" [style.color]="t.color" style="font-weight:600;">{{ t.labelKey | translate }}</div>
        </div>
      </div>

      <!-- Step2 change5: delayed-recall cue-benefit sentence (explanation, not a score) -->
      <div *ngIf="t.recallInsight" style="margin-top:10px;padding-top:10px;border-top:1px solid var(--g100);font-size:12.5px;color:var(--g600);line-height:1.65;">
        {{ t.recallInsight.key | translate: recallParams(t.recallInsight) }}
      </div>

      <!-- Step2 change6: working-memory backward-cost sentence + numeric caption -->
      <div *ngIf="t.wmInsight" style="margin-top:10px;padding-top:10px;border-top:1px solid var(--g100);">
        <p style="font-size:12.5px;color:var(--g600);line-height:1.65;margin:0;">{{ t.wmInsight.key | translate }}</p>
        <p style="font-size:11px;color:var(--g400);margin:5px 0 0;">{{ 'results.th.wmCaption' | translate: { forward: t.wmInsight.forward, backward: t.wmInsight.backward } }}</p>
      </div>
    </div>

    <p style="font-size:11px;color:var(--g400);font-style:italic;margin-top:12px;line-height:1.5;">{{ 'results.th.deepDisclaimer' | translate }}</p>
  </details>

  <!-- KEEP IN MIND -->
  <div class="warm-message-sage warm-message" style="margin-top:12px;" [attr.data-label]="'results.th.keepLabel' | translate">
    {{ 'results.th.keepBody' | translate }}
  </div>

  <!-- TOOLS WE OFFER -->
  <app-tools-recommendation domain="think"></app-tools-recommendation>
</ng-container>
